const DollarIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Small bottle */}
      <path
        d="M9 14h4v2.5c1.2.4 2 1.4 2 2.8V32H7V19.3c0-1.4.8-2.4 2-2.8V14z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M10.5 10v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M9.2 10h2.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />

      {/* Medium bottle */}
      <path
        d="M18 11h4v2.5c1.2.4 2 1.4 2 2.8V32h-8V16.3c0-1.4.8-2.4 2-2.8V11z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M19.5 7v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M18.2 7h2.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />

      {/* Tall bottle */}
      <path
        d="M27 8h4v2.5c1.2.4 2 1.4 2 2.8V32h-8V13.3c0-1.4.8-2.4 2-2.8V8z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M28.5 4v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M27.2 4h2.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />

      {/* Minimal price marks on labels */}
      <path d="M9 22h4M9 25h2.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" opacity="0.55" />
      <path d="M18 19h4M18 22h2.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" opacity="0.55" />
      <path d="M27 16h4M27 19h2.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" opacity="0.55" />
    </svg>
  );
};

export default DollarIcon;
